var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronBackGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6px",
    height: "8px",
    viewBox: "0 0 6 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC4riklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Error---Generic",
    transform: "translate(-681.000000, -601.000000)",
    stroke: "#909090",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(464.000000, 275.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(171.000000, 307.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(48.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3",
    transform: "translate(1.500000, 9.000000) rotate(90.000000) translate(-1.500000, -9.000000) ",
    points: "-1.5 7.5 1.5 10.5 4.5 7.5"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronBackGray);
export default __webpack_public_path__ + "static/media/Chevron_Back_Gray.0faf5e6bdf606697e7f94dd3faec3e44.svg";
export { ForwardRef as ReactComponent };